import React from "react";
import ReactDOM from "react-dom/client";
import "./CSS/tailwind.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Sentry from "@sentry/browser";
// import { installKetchTag } from "./utils/ketchTag";

const SENTRY_DSN =
  process.env.REACT_APP_SENTRY_DSN ||
  "https://ffe738dfa3fdbdb3e97bed199a562dfe@o4511655463682048.ingest.us.sentry.io/4511655472070656";

Sentry.init({
  dsn: SENTRY_DSN,
  environment: process.env.NODE_ENV,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  ignoreErrors: [
    "ResizeObserver loop completed with undelivered notifications.",
    "ResizeObserver loop limit exceeded",
  ],
  denyUrls: [
    /extensions\//i,
    /^chrome:\/\//i,
    /^chrome-extension:\/\//i,
    /^moz-extension:\/\//i,
    /^safari-web-extension:\/\//i,
  ],
  tracesSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 1.0,
  replaysSessionSampleRate: process.env.NODE_ENV === "production" ? 0.01 : 1.0,
  replaysOnErrorSampleRate: 1.0,
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/kre8content\.com/,
    /^https:\/\/editor-98cc4\.web\.app/,
    /^https:\/\/.*\.cloudfunctions\.net/,
  ],
});

// Temporarily disabled while investigating black screens in in-app browsers.
// installKetchTag();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
/>
    <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);

reportWebVitals();
